interface IBreadcrumb {
  icon?: any,
  title: string,
  routeName?: string,
  params?: any
}

const breadcrumbs: IBreadcrumb[] = []

export default {
  breadcrumbs,
}